(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fly-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fly-video-stage')) {
    class FlyVideoStage extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('.fly-stage__toggle');
        if (!this.toggle) return;

        this.mediaQuery = window.matchMedia('(max-width: 47.99rem)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onToggle = () => this.togglePlayback();
        this.onViewportChange = () => this.syncActiveVideo();
        this.toggle.addEventListener('click', this.onToggle);
        this.mediaQuery.addEventListener('change', this.onViewportChange);
        this.syncActiveVideo();

        if (this.dataset.autoplay === 'true' && this.dataset.motion === 'true' && !this.reducedMotion.matches) {
          this.observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) this.play();
            else this.pause();
          }, { rootMargin: '100px 0px', threshold: 0.35 });
          this.observer.observe(this);
        }
      }

      getActiveVideo() {
        const mobile = this.querySelector('.fly-stage__video--mobile video');
        const desktop = this.querySelector('.fly-stage__video--desktop video');
        return this.mediaQuery?.matches && mobile ? mobile : desktop || mobile;
      }

      syncActiveVideo() {
        const nextVideo = this.getActiveVideo();
        if (this.video && this.video !== nextVideo) this.video.pause();
        this.video = nextVideo;
        this.pause();
      }

      togglePlayback() {
        if (!this.video || this.reducedMotion.matches) return;
        if (this.video.paused) this.play();
        else this.pause();
      }

      play() {
        if (!this.video || this.reducedMotion.matches) return;
        this.video.play().then(() => {
          this.classList.add('is-playing');
          this.toggle.setAttribute('aria-pressed', 'true');
          this.toggle.querySelector('.fly-stage__toggle-icon').textContent = 'Ⅱ';
          this.toggle.querySelector('.fly-stage__toggle-label').textContent = this.toggle.dataset.pauseLabel;
        }).catch(() => {});
      }

      pause() {
        this.video?.pause();
        this.classList.remove('is-playing');
        this.toggle?.setAttribute('aria-pressed', 'false');
        if (this.toggle) {
          this.toggle.querySelector('.fly-stage__toggle-icon').textContent = '▶';
          this.toggle.querySelector('.fly-stage__toggle-label').textContent = this.toggle.dataset.playLabel;
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.toggle?.removeEventListener('click', this.onToggle);
        this.mediaQuery?.removeEventListener('change', this.onViewportChange);
      }
    }

    customElements.define('fly-video-stage', FlyVideoStage);
  }

  } catch(e) { console.error(e); }
})();
})();
